import { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import Visibility from "@material-ui/icons/Visibility";
import { useAttendanceLocalMapStyles } from "./styles";
import { Totem } from "../../../../../../../@types/totem";
import { useTotemStyles } from "../../../../../styles";

type Props = {
  totem: Totem
};

export default function TotemLogoPreview({ totem }: Props) {
  const [open, setOpen] = useState(false);
  const { classes: defaultClasses } = useTotemStyles();
  const { classes } = useAttendanceLocalMapStyles();

  function handleDownloadLogo() {
    const link = document.createElement('a');
    link.href = totem.logo;
    link.download = `logo-${totem.descricao}.png`;
    link.rel = "noopener noreferrer";
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <>
      <Button
        startIcon={<Visibility fontSize="small" />}
        className={classes.button}
        onClick={() => setOpen(true)}
      >
        Visualizar Logo
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
        <Card>
          <CardHeader
            avatar={<Visibility />}
            title={<Typography variant="h5">Logo</Typography>}
            className={classes.cardHeader}
          />
          <CardContent className={classes.cardContent}>
            <img
              src={totem?.logo || ""}
              alt={`Logo do totem ${totem?.descricao}`}
              className={classes.logoImage}
            />
          </CardContent>
          <CardActions className={classes.cardActions}>
            <Button
              className={classes.button}
              onClick={() => setOpen(false)}
            >
              Fechar
            </Button>
            <Button
              className={defaultClasses.addButton}
              onClick={handleDownloadLogo}
            >
              Baixar
            </Button>
          </CardActions>
        </Card>
      </Dialog>
    </>
  );
}
